import { useNavigate } from 'react-router-dom';
import { Card, CardBody, Button } from 'reactstrap';
import { useAuth } from '../auth/AuthProvider';

export function NoAccessPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <Card style={{ maxWidth: 560 }}>
        <CardBody>
          <h2 className="mb-3 text-center">Kein Operator-Zugriff</h2>
          <p className="text-muted">
            Dieses Konto hat keine Membership in einer Brand mit{' '}
            <code>staff</code>- oder <code>admin</code>-Rolle. Bitte melde dich
            beim Operator-Admin, um zu den passenden Brands hinzugefügt zu werden.
          </p>

          <div className="text-center mt-3">
            <Button
              color="secondary"
              onClick={() => {
                auth.signOut();
                navigate('/login', { replace: true });
              }}
            >
              Abmelden
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
